import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiAddWorldShowcaseItemVariables = Types.Exact<{
  featuredItem: Types.ApiFeaturedItemByOneOfInput;
  worldId: Types.Scalars['Int'];
}>;


export type ApiAddWorldShowcaseItem = { addWorldFeaturedItem: { __typename: 'DropCollection', contractAddress: Address } | { __typename: 'EditionCollection', contractAddress: Address } | { __typename: 'MarketNft', tokenId: number, nftContractAddress: Address } | { __typename: 'Moment' } };



export const ApiAddWorldShowcaseItemDocument = /*#__PURE__*/ `
    mutation AddWorldShowcaseItem($featuredItem: FeaturedItemByOneOfInput!, $worldId: Int!) {
  addWorldFeaturedItem(featuredItem: $featuredItem, worldId: $worldId) {
    __typename
    ... on EditionCollection {
      contractAddress
    }
    ... on DropCollection {
      contractAddress
    }
    ... on MarketNft {
      nftContractAddress: contractAddress
      tokenId
    }
  }
}
    `;

export const useAddWorldShowcaseItem = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiAddWorldShowcaseItem, TError, ApiAddWorldShowcaseItemVariables, TContext>) => {
    
    return useMutation<ApiAddWorldShowcaseItem, TError, ApiAddWorldShowcaseItemVariables, TContext>(
      {
    mutationKey: ['AddWorldShowcaseItem'],
    mutationFn: (variables?: ApiAddWorldShowcaseItemVariables) => apiFetcher<ApiAddWorldShowcaseItem, ApiAddWorldShowcaseItemVariables>(ApiAddWorldShowcaseItemDocument, variables)(),
    ...options
  }
    )};


useAddWorldShowcaseItem.fetcher = (variables: ApiAddWorldShowcaseItemVariables, options?: RequestInit['headers']) => apiFetcher<ApiAddWorldShowcaseItem, ApiAddWorldShowcaseItemVariables>(ApiAddWorldShowcaseItemDocument, variables, options);
